import { INTAKE_SITE_US1, INTAKE_URL_PARAMETERS } from '../intakeSites';
import { createEndpointBuilder } from './endpointBuilder';
export function computeTransportConfiguration(initConfiguration) {
    const site = initConfiguration.site || INTAKE_SITE_US1;
    const endpointBuilders = computeEndpointBuilders(initConfiguration);
    const replicaConfiguration = computeReplicaConfiguration(initConfiguration);
    return {
        replica: replicaConfiguration,
        site,
        ...endpointBuilders,
    };
}
function computeEndpointBuilders(initConfiguration) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs'),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum'),
        profilingEndpointBuilder: createEndpointBuilder(initConfiguration, 'profile'),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'replay'),
    };
}
function computeReplicaConfiguration(initConfiguration) {
    if (!initConfiguration.replica) {
        return;
    }
    const replicaConfiguration = {
        ...initConfiguration,
        site: INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    };
    const replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs'),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum'),
    };
    return { applicationId: initConfiguration.replica.applicationId, ...replicaEndpointBuilders };
}
export function isIntakeUrl(url) {
    // check if tags is present in the query string
    return INTAKE_URL_PARAMETERS.every((param) => url.includes(param));
}
//# sourceMappingURL=transportConfiguration.js.map